module.exports = __webpack_public_path__ + "static/media/left-arrow.7324e7ac.svg";